import PropTypes from "prop-types";
import React from "react";
import { connect, } from "react-redux";
import { firestoreConnect, } from "react-redux-firebase";
import { compose } from "redux";
import {
    Header,
    Icon,
    Segment,
} from "semantic-ui-react";
import {
    createContext,
    createSubmission,
    toggleActiveContext,
    updateContext,
} from "./actions";
import ContextBody from "./ContextBody";
import ContextHeader from "./ContextHeader";
import LoadingSegment from "./util/LoadingSegment";
import STATUS from "./util/STATUS";

class ContextList extends React.PureComponent {

    render() {
        const {
            isDm,
            contexts,
            createContext,
            activeContext,
            toggleContext,
            updateContext,
            createSubmission,
        } = this.props;
        if (!contexts) {
            return <LoadingSegment text="Loading contexts..." />;
        }
        if (contexts.length === 0) {
            return <Segment>
                <Header>
                    <Icon name="plus" />
                    <Header.Content>
                        No Contexts
                        <Header.Subheader>
                            <a onClick={createContext}>Create Context</a>
                        </Header.Subheader>
                    </Header.Content>
                </Header>
            </Segment>;
        }
        return contexts.map(c =>
            <Segment.Group key={c.id}>
                <ContextHeader isDm={isDm}
                               onClick={() => toggleContext(c.id)}
                               context={c}
                />
                {c.id === activeContext
                && <ContextBody isDm={isDm}
                                context={c}
                                updateContext={fs =>
                                    updateContext(c.id, fs)}
                                createSubmission={(r, d) =>
                                    createSubmission(c.id, r, d)}
                />}
            </Segment.Group>,
        );
    }
}

ContextList.propTypes = {
    isDm: PropTypes.bool.isRequired,
    contexts: PropTypes.array,
    activeContext: PropTypes.string,
    toggleContext: PropTypes.func.isRequired,
    updateContext: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    activeContext: state.activeContext,
    contexts: state.firestore.ordered.contexts,
});

// noinspection JSUnusedGlobalSymbols
const mapDispatchToProps = dispatch => ({
    createContext: () =>
        dispatch(createContext()),
    toggleContext: id =>
        dispatch(toggleActiveContext(id)),
    updateContext: (id, newFields) =>
        dispatch(updateContext(id, newFields)),
    createSubmission: (cid, region, data) =>
        dispatch(createSubmission(cid, region, data)),
});

export default compose(
    firestoreConnect(function ({ isDm }, store) {
        const { contextFilter } = store.getState();
        const q = {
            collection: "contexts",
            orderBy: [
                ["createdAt", "desc"],
            ],
            where: [],
        };
        if (isDm) {
            q.where.push(["status", "==", contextFilter]);
        } else {
            q.where.push(["status", "==", STATUS.PUBLISHED]);
        }
        return [q];
    }),
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ContextList);



// WEBPACK FOOTER //
// ./src/ContextList.js